export default __webpack_public_path__ + "static/media/close.a6b6b1f0.svg";